module.exports = __webpack_public_path__ + "assets/img/9fa6dd50fc2080c7bbc988ae05eeaa63.svg";